import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import ButtonSave from "../../../components/ButtonComponent/ButtonSave";
import { CardContent, CardTitle } from "../../../components/Card-z";
import { GroupInput, GroupSelect } from "../../../components/Form";
import { Modal } from "../../../components/Modal-z";
import CONNECT_API from "../../../configs/connect";
import { ShowError } from "../../../configs/Functions";
import { useIsLoading } from "../../../contexts/LoadingContext";

const ModalEditMenu = (props) => {
    const [menu, setMenu] = useState([]);
    const [menuTree, setMenuTree] = useState([]);
    const [modulos, setModulos] = useState([]);
    const { setIsLoading } = useIsLoading();
    const { register, reset, handleSubmit } = useForm();
    const menu_id = props?.menu_id;

    async function get_data_page() {
        if (!menu_id) return false;
        try {
            setIsLoading(true);
            const { data } = await CONNECT_API.get("/admin/menus/" + menu_id);
            setMenu(data.menu);
            setModulos(data.modulos);
            setMenuTree(data.menu_tree);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            ShowError(error);
        }
    }

    // edição do menu
    async function onSubmit(formData) {
        if (!menu_id) return false;
        try {
            setIsLoading(true);

            await CONNECT_API.put(`/admin/menu/${menu_id}`, {
                ...formData,
            });

            setIsLoading(false);
            if (props.loaded) await props.loaded();
        } catch (error) {
            setIsLoading(false);
            ShowError(error);
        }
    }

    useEffect(() => {
        get_data_page();
        // eslint-disable-next-line
    }, [menu_id]);

    useEffect(() => {
        reset({
            ...menu,
        });
        // eslint-disable-next-line
    }, [menu]);

    return (
        <Modal modalId={props.modalId} modalShow={get_data_page}>
            <CardContent>
                <CardTitle>
                    ID {menu?.id} - {menu?.label}
                </CardTitle>
                <div className="col-12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <GroupSelect
                                name="ativo"
                                col="3"
                                label="Situação"
                                register={register}
                            >
                                <option value="0">Inativo</option>
                                <option value="1">Ativa</option>
                            </GroupSelect>
                            <GroupInput
                                name="label"
                                col="6"
                                label="Nome"
                                register={register}
                            />
                            <GroupInput
                                name="icon"
                                col="3"
                                label="Icone"
                                register={register}
                            />
                            <GroupInput
                                name="url"
                                col="5"
                                label="URL"
                                register={register}
                            />
                            <GroupInput
                                name="color"
                                type="color"
                                col="4"
                                label="Cor de Fonte"
                                register={register}
                            />
                            <GroupSelect
                                name="show"
                                col="3"
                                label="Exibição"
                                register={register}
                            >
                                <option value="0">Hide</option>
                                <option value="1">Show</option>
                            </GroupSelect>
                            <GroupSelect
                                name="modulo_id"
                                col="5"
                                label="Módulo"
                                register={register}
                            >
                                {modulos?.map((m) => (
                                    <option key={m?.id} value={m?.id}>
                                        {m?.nome}
                                    </option>
                                ))}
                            </GroupSelect>
                            <GroupSelect
                                name="parent_id"
                                col="7"
                                label="Parent ID"
                                register={register}
                            >
                                <option value="">Menu Principal</option>
                                {menuTree?.map((m) => (
                                    <React.Fragment key={m?.id}>
                                        {menu_tree(m?.menu)}
                                    </React.Fragment>
                                ))}
                            </GroupSelect>
                        </div>
                        <ButtonSave type="submit" className="float-right" />
                    </form>
                </div>
            </CardContent>
        </Modal>
    );
};

export default ModalEditMenu;

// MONATANDO A ARVORE DE SUB ITENS
function menu_tree(m) {
    const mp = m?.map((menu) => {
        const op = (
            <React.Fragment key={menu?.id}>
                <option key={menu?.id} value={menu?.id}>
                    MD{menu?.modulo_id} - {menu.labels || menu?.label}
                </option>
                {menu_tree(menu.sub_menu)}
            </React.Fragment>
        );
        return op;
    });
    return mp;
}
